var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function initSidebar() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const sidebar = document.querySelector('.sidebar');
        const sidebarContentItems = document.querySelectorAll('.sidebar__item-content');
        const width = window.innerWidth;
        const heroSize = 1200;
        const introElement = document.querySelector('.intro.frame');
        const design2025Active = (_a = (introElement)) === null || _a === void 0 ? void 0 : _a.classList.contains('design-2025');
        if (!sidebar)
            return;
        if (!design2025Active) {
            if (width >= heroSize)
                sidebar.classList.add('active');
        }
        else {
            // Top position of intro mask element + half height of intro mask element - half height of sidebar
            const sidebarTopStart = introElement.getBoundingClientRect().top + (introElement.offsetHeight / 2) - (sidebar.offsetHeight / 2);
            sidebar.classList.add('active');
            sidebar.style.top = sidebarTopStart + 'px';
        }
        function appearOnScroll() {
            if (!design2025Active) {
                if (width > heroSize)
                    return;
                if (window.pageYOffset > 200) {
                    sidebar.classList.add('active');
                }
                else {
                    sidebar.classList.remove('active');
                }
            }
            else {
                // Top position of intro mask element - height of intro mask element
                const scrollOffset = introElement.getBoundingClientRect().top - introElement.offsetHeight;
                if (scrollOffset > 0) {
                    // Top position of intro mask element + half height of intro mask element - half height of sidebar
                    const sidebarTop = introElement.getBoundingClientRect().top + (introElement.offsetHeight / 2) - (sidebar.offsetHeight / 2);
                    sidebar.style.top = sidebarTop + 'px';
                }
                else {
                    sidebar.removeAttribute('style');
                }
            }
        }
        window.addEventListener('scroll', appearOnScroll);
        sidebarContentItems === null || sidebarContentItems === void 0 ? void 0 : sidebarContentItems.forEach((item) => {
            const openButton = item.querySelector('.sidebar__icon');
            const closeButton = item.querySelector('.sidebar__close');
            const content = item.querySelector('.sidebar__content');
            closeButton.addEventListener('click', () => {
                content.classList.remove('sidebar__content--open');
            });
            item.addEventListener('mouseleave', () => {
                content.classList.remove('sidebar__content--open');
            });
            openButton.addEventListener('mouseenter', () => {
                sidebarContentItems.forEach((item) => {
                    item
                        .querySelector('.sidebar__content')
                        .classList.remove('sidebar__content--open');
                    return;
                });
                content.classList.add('sidebar__content--open');
            });
        });
    });
}
